<template>
  <div
    class="disable-favorites"
    style="position: relative"
    ref="desktopContainer"
    v-resize="onResize"
  >
    <div
      ref="luciApril"
      style="
        position: absolute;
        transform: scale(1, -1);
        top: -60px;
        left: 0px;
        z-index: 1;
        display: none;
      "
    >
      <img
        style="width: 50px; height: 50px"
        :src="$model.wwwroot + '/blocks/psm_desktop2/luci.gif'"
      />
    </div>

    <div class="d-flex flex-wrap justify-space-between">
      <div class="d-flex flex-wrap justify-start">
        <v-btn
          size="small"
          variant="text"
          class="mr-2 mb-2"
          prepend-icon="mdi-plus"
          @click="widgetAddDialog = true"
        >
          <template v-slot:prepend>
            <v-icon color="success"></v-icon>
          </template>
          Добавить виджет
        </v-btn>
        <v-btn
          v-if="$model.isAdmin"
          size="small"
          variant="text"
          class="mr-2 mb-2"
          prepend-icon="mdi-pencil-plus"
          @click="
            announceDialogType = 'edit';
            announceShowDialog = true;
          "
        >
          <template v-slot:prepend>
            <v-icon color="success"></v-icon>
          </template>
          Создать объявление
        </v-btn>
        <v-btn
          v-if="$model.isAdmin"
          size="small"
          variant="text"
          class="mr-2 mb-2"
          prepend-icon="mdi-archive-edit"
          @click="
            announceDialogType = 'list';
            announceShowDialog = true;
          "
        >
          <template v-slot:prepend>
            <v-icon color="success"></v-icon>
          </template>
          Архив объявлений
        </v-btn>
      </div>
      <div class="d-flex justify-end">
        <v-btn
          size="small"
          variant="text"
          class="mr-2 mb-2"
          :prepend-icon="store.fixed ? 'mdi-lock' : 'mdi-lock-open-variant'"
          @click="store.fixed = !store.fixed"
        >
          Закрепить
        </v-btn>

        <v-btn
          size="small"
          variant="text"
          class="mr-2 mb-2"
          :prepend-icon="
            store.mode ? 'mdi-window-maximize' : 'mdi-window-minimize'
          "
          @click="store.mode = !store.mode"
        >
          Режим отображения
        </v-btn>
      </div>
    </div>

    <newsList
      v-if="news.length"
      :list="news"
    ></newsList>

    <div class="desktop_widget_row">
      <VueDraggable
        v-model="userWidgets"
        :disabled="store.fixed"
        :class="[
          store.fixed ? 'cursor-auto' : 'cursor-move',
          'v-row',
          'v-row--density-default',
        ]"
        handle=".v-system-bar"
        ghost-class="ghost"
        @update="changeWidgetOrder"
      >
        <v-col
          v-for="element in userWidgets"
          :key="element.name"
          v-bind="getWidgetCols(element)"
          class="my-2"
        >
          <v-card
            density="compact"
            style="height: 100%"
            :variant="
              showWidgetContent &&
              element.widgetName == showWidgetContent.widgetName
                ? 'outlined'
                : 'elevated'
            "
          >
            <v-layout>
              <v-system-bar>
                <span class="text-truncate">{{ element.displayName }}</span>
                <v-btn
                  v-if="$model.isAdmin"
                  size="small"
                  density="compact"
                  icon="mdi-share-variant"
                  variant="plain"
                  @click="shareWidget(element)"
                ></v-btn>

                <v-spacer></v-spacer>

                <v-btn
                  v-if="
                    !store.fixed &&
                    isWidgetResizable(element) &&
                    element.cols.cols < 12
                  "
                  size="small"
                  density="compact"
                  icon="mdi-arrow-expand"
                  variant="plain"
                  @click="
                    element.cols.cols = parseInt(element.cols.cols) + 2;
                    changeWidgetSize(element);
                  "
                ></v-btn>
                <v-btn
                  v-if="
                    !store.fixed &&
                    isWidgetResizable(element) &&
                    element.cols.cols > 2
                  "
                  size="small"
                  icon="mdi-arrow-collapse"
                  variant="plain"
                  @click="
                    element.cols.cols = parseInt(element.cols.cols) - 2;
                    changeWidgetSize(element);
                  "
                ></v-btn>

                <v-btn
                  v-if="!store.fixed"
                  size="small"
                  density="compact"
                  icon="mdi-close"
                  variant="plain"
                  @click="deleteWidget(element)"
                ></v-btn>
              </v-system-bar>
            </v-layout>
            <!--на мобильном дейвайсе тап по иконке открывает виджет-->
            <component
              :style="
                showWidgetContent &&
                element.widgetName == showWidgetContent.widgetName &&
                !isMobile
                  ? 'filter: brightness(90%);'
                  : ''
              "
              :class="
                store.mode && element.contentOutWidget
                  ? 'hover widget'
                  : 'widget'
              "
              @click="
                store.mode && element.contentOutWidget
                  ? (showWidgetContent = element)
                  : null
              "
              v-if="element.widgetName"
              :is="element.widgetName"
              :data="element.data"
              :showContent="
                !store.mode || (isMobile && showWidgetContent == element)
                  ? true
                  : false
              "
            />
          </v-card>
        </v-col>
      </VueDraggable>
    </div>
    <v-card v-if="showWidgetContent && store.mode && !isMobile">
      <v-card-text>
        <KeepAlive>
          <component
            :is="showWidgetContent.widgetName"
            :data="showWidgetContent.data"
            :showContent="true"
          />
        </KeepAlive>
      </v-card-text>
    </v-card>

    <addWidget
      v-model="widgetAddDialog"
      @widget-add="loadUserWidgets"
      :widgets="widgetsToAdd"
    ></addWidget>
    <announceDialog
      v-model:type="announceDialogType"
      v-model="announceShowDialog"
    >
    </announceDialog>
    <shareWidgetDialog
      v-model="shareDialog"
      :widgetData="shareWidgetData"
    ></shareWidgetDialog>
  </div>
</template>

<script>
import { VueDraggable } from "vue-draggable-plus";
import { getCurrentInstance } from "vue";
import addWidget from "./addWidget.vue";
import announceDialog from "./announceDialog.vue";
import newsList from "./announceDesktopList.vue";
import shareWidgetDialog from "./shareWidgetDialog.vue";
export default {
  name: "desktop2",
  components: {
    VueDraggable,
    addWidget,
    announceDialog,
    newsList,
    shareWidgetDialog,
  },
  data() {
    return {
      widgetAddDialog: false,
      announceShowDialog: false,
      shareDialog: false,
      shareWidgetData: null,
      announceDialogType: "edit",
      userWidgets: [],

      allAvailableSettings: [],
      allAvailableWidgets: [],
      allowedToAddWidgets: [],

      widgetsToAdd: [],

      news: [],
      //false - показать сонтент внутри виджета, true-в отдельной области
      store: {
        mode: true,
        fixed: false,
      },
      showWidgetContent: null,
      rmWidgetAbortControl: [],
      //--------------------luciWalk---------------------------------------
      lucieInstance: null,
      blockX: 0,
      blockY: 0,
      rotate: 0,
      typed: "",
    };
  },
  created() {
    //load all available widgets
    Object.entries(getCurrentInstance().appContext.components).forEach(
      ([name]) => {
        let wname = name.match(/^psm_desktop2_(.+_settings)$/);
        if (wname) {
          this.allAvailableSettings.push(wname[0]);
        }

        wname = name.match(/^psm_desktop2_(.+_widget)$/);
        if (wname) {
          this.allAvailableWidgets.push(wname[0]);
        }
      },
    );

    if (this.$model.store && this.$model.store.DesktopStore) {
      this.store = this.$model.store.DesktopStore;
    }

    this.getNews();
    this.allowedToAddWidgets = this.$model.WidgetComponents;
    this.userWidgets = this.$model.UserWidgets;
    this.filterAllowedComponents();
  },
  mounted() {
    window.addEventListener("keydown", this.keydown);
    /*
    setTimeout(() => {
      this.onResize()
      this.luciWalk()
    }, 10000);
    */
  },
  unmounted() {
    window.removeEventListener("keydown", this.keydown);
  },
  computed: {
    isMobile() {
      //для $vuetify.display.mobile md уже мобильный девайс
      return this.$vuetify.display.mobile && this.$vuetify.display.name == "xs";
    },
  },
  watch: {
    /*'$vuetify.display.name': {
      handler(nv, ov) {
        console.log('New value:', nv);
        console.log('Old value:', ov);
      },
    },*/
    store: {
      handler(val) {
        this.axios
          .post(
            this.$model.wwwroot + "/procollege/psm_desktop2/setStorage",
            new URLSearchParams({
              data: JSON.stringify(this.store),
            }),
          )
          .then((response) => {})
          .catch((error) => {
            console.log(error);
          });
      },
      deep: true,
    },
  },
  methods: {
    onResize() {
      //padding внешнего блока 10 5, по нему "идем"
      //размер блока картинки 50, отступы изображения примерно 10px
      this.blockX = this.$refs.desktopContainer.clientWidth;
      this.blockY = this.$refs.desktopContainer.clientHeight;
    },
    //--------easteregg-----------------
    keydown(event) {
      if (!this.lucieInstance) {
        if (event.key == "6") {
          this.typed += "6";
        } else {
          this.typed = "";
        }
        if (this.typed == "666") {
          this.onResize();
          this.luciWalk();
          this.typed = "";
        }
      }
      if (this.lucieInstance) {
        if (event.key == "9") {
          this.typed += "9";
        } else {
          this.typed = "";
        }
        if (this.typed == "999") {
          clearInterval(this.lucieInstance);
          let luci = this.$refs.luciApril;
          luci.style.display = "none";
          this.lucieInstance = null;
          this.typed = "";
        }
      }
    },
    luciWalk() {
      let rotate = () => {
        switch (this.rotate) {
          case 0:
            this.rotate = 90;
            luci.style.left = luciePosition + "px";
            luciePosition = 0;
            break;
          case 90:
            this.rotate = 180;
            luci.style.top = luciePosition + "px";
            luciePosition = 0;
            break;
          case 180:
            this.rotate = 270;
            luci.style.left = "-20px";
            luciePosition = 0;
            break;
          case 270:
            this.rotate = 0;
            luci.style.top = "-60px";
            luciePosition = 0;
            break;
        }
      };
      let luci = this.$refs.luciApril;
      luci.style.display = "block";

      let luciePosition = 0;
      this.lucieInstance = setInterval(() => {
        if (
          ([0].indexOf(this.rotate) > -1 && luciePosition > this.blockX - 30) ||
          ([180].indexOf(this.rotate) > -1 &&
            luciePosition > this.blockX - 20) ||
          ([90].indexOf(this.rotate) > -1 &&
            luciePosition > this.blockY - 30) ||
          ([270].indexOf(this.rotate) > -1 && luciePosition > this.blockY - 10)
        ) {
          rotate();
        }
        luci.style["transform"] =
          "rotate(" +
          this.rotate +
          "deg) scale(1,-1) translateX(" +
          luciePosition +
          "px)";
        luciePosition += 5;
      }, 70);
    },
    shareWidget(element) {
      this.shareWidgetData = element;
      this.shareDialog = true;
    },
    getWidgetCols(element) {
      //всё кроме ссылок на мобиле во всю ширину
      if (element.name != "hyperlink" && this.isMobile) {
        return { cols: 12 };
      }
      //мобила или компактный режим
      if (this.isMobile || this.store.mode) {
        return {
          cols: 12,
          sm: 3,
          md: 2,
        };
      }

      return element.cols;
    },
    isWidgetResizable(element) {
      if (
        this.$vuetify.display.mobile ||
        this.store.mode ||
        !element.resizable
      ) {
        return false;
      }

      return true;
    },
    deleteWidget(element) {
      //быстрое удаление всех виджетов
      //интересен ответ только на последний запрос, остальные можно прервать
      let AbortControl;
      while ((AbortControl = this.rmWidgetAbortControl.pop())) {
        AbortControl.abort();
      }
      //------------------------------------------
      AbortControl = new AbortController();
      this.rmWidgetAbortControl.push(AbortControl);
      //------------------------------------------
      this.userWidgets = this.userWidgets.filter((el) => {
        return element.id != el.id;
      });

      this.axios
        .post(
          this.$model.wwwroot + "/procollege/psm_desktop2/deleteWidget",
          new URLSearchParams({
            id: element.id,
          }),
          {
            signal: AbortControl.signal,
          },
        )
        .then((response) => {
          this.userWidgets = response.data;
          this.filterAllowedComponents();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    loadUserWidgets(widgetList) {
      this.userWidgets = widgetList;
      this.filterAllowedComponents();
    },
    filterAllowedComponents() {
      this.userWidgets.forEach((el) => {
        this.allAvailableWidgets.forEach((available) => {
          if (available.includes(el.name)) {
            el.widgetName = available;
          }
        });
      });

      this.widgetsToAdd = this.allAvailableSettings.filter((el) => {
        for (const [key, value] of Object.entries(this.allowedToAddWidgets)) {
          //console.log(el)//psm_desktop2_widgets_hyperlink_settings
          //console.log(key)//hyperlink
          //console.log(value)//object{class,allow,multiple}
          let alreadyExists = this.userWidgets.some((str) => {
            return el.includes(str.name);
          });
          if (
            el.includes(key) &&
            value.allow &&
            (value.multiple || !alreadyExists)
          ) {
            return true;
          }
        }
        return false;
      });
    },
    changeWidgetOrder: function (e) {
      let indexes = this.userWidgets.map((el) => {
        return el.id;
      });
      this.axios
        .post(
          this.$model.wwwroot + "/procollege/psm_desktop2/changeWidgetOrder",
          new URLSearchParams({
            newOrder: JSON.stringify(indexes),
          }),
        )
        .then((response) => {})
        .catch((error) => {
          console.log(error);
        });
    },
    getNews() {
      this.axios
        .post(this.$model.wwwroot + "/procollege/psm_desktop2/getNews")
        .then((response) => {
          this.news = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    changeWidgetSize(widget) {
      this.axios
        .post(
          this.$model.wwwroot + "/procollege/psm_desktop2/changeWidgetSize",
          new URLSearchParams({
            id: widget.id,
            cols: JSON.stringify(widget.cols),
          }),
        )
        .then((response) => {})
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
<style lang="scss">
.main-inner {
  //moodle 5 ограничивает ширину
  max-width: 100% !important;
}

#procollege_desktop2 {
  .desktop_widget_row {
    margin: 0 !important;
  }

  .buttons {
    margin-top: 35px;
  }

  .ghost {
    opacity: 0.5;
    background: gray;
  }

  .v-system-bar {
    position: inherit !important;
    left: inherit !important;
    top: inherit !important;
    width: inherit !important;
  }

  .widget {
    background-color: white;
    height: 100%;
  }

  .widget.hover:hover {
    opacity: 0.5;
  }

  .v-card {
    padding: 0;
  }
}
</style>
